export const taxesEvent = {
  TAX_PAGE_VIEWED: "Accounting Settings Details Viewed",
  ADD_TAXES: "Accounting Settings Create Button Clicked",
  EDIT_TAXES: "Accounting Settings Edited",
};
